export const baseRoute = '/crm/smart-alerts'
